/* eslint-disable arrow-body-style */
import React from 'react';
import { ResultsStatus } from '@src/common/types';
import { useEventSearchResultsStore } from '../../../mothership/eventSearchResults.state';
import { ResultsError } from '../../../../../../common/FilterPanelPage/results/ResultsError';
import { ColumnSelectorDrawer } from './ColumnSelectorDrawer';
import { EventItemDetailsDrawer } from './EventItemDetailDrawer';
import { LoadTrigger } from './LoadTrigger';
import { ResultsTableBody } from './ResultsTableBody';
import { ResultsTableControls } from './ResultsTableControls';
import { ResultsTableHead } from './ResultsTableHead';
import { ResultsSearchingTable } from '../ResultsSearchingTable';
import { eventSearchId } from '../../../types';

export const ResultsTable = () => {
  const tableResultsStatus = useEventSearchResultsStore(
    (state) => state.tableResultsStatus
  );

  if (tableResultsStatus === ResultsStatus.error) {
    return (
      <div className="eventSearchTableResults">
        <ResultsError id={eventSearchId} />
      </div>
    );
  }

  if (tableResultsStatus === ResultsStatus.searching) {
    return (
      <div className="eventSearchTableResults">
        <ResultsSearchingTable />
      </div>
    );
  }

  return (
    <React.Fragment>
      <EventItemDetailsDrawer />
      <ColumnSelectorDrawer />
      <ResultsTableControls />
      <div
        data-testid="event-search-table"
        data-cy="event-search-table"
        className="defeds-table-container"
      >
        <table className="defeds-table">
          <ResultsTableHead />
          <ResultsTableBody />
        </table>
      </div>
      <LoadTrigger />
    </React.Fragment>
  );
};
